import TestImage from "../assets/panel_surya.jpg"
import Video from "../assets/nusa_video.mp4"

export default function TeknologiKami(params) {
    return (
        <>
            <div className="lg:mx-16 p-2">
                <div className="lg:flex lg:max-w-full mb-5 w-full">
                    <div className="lg:p-6 lg:ml-8 lg:w-1/2  p-4">
                        <div>
                            <h2 className="mb-9 text-4xl font-bold text-gray-900">Teknologi Terbaik di Energi Masa Depan </h2>
                            <p className="text-gray-600 text-1xl">Kami menggunakan komponen-komponen terbaik dalam menyediakan <p className="font-bold"> energi masa depan </p> dengan dukungan pabrik lokal dan tenaga ahli yang berpengalaman. </p>
                         </div>
                    </div>
                    <img src={TestImage} alt=''
                        className="w-1/1 lg:w-1/3 lg:h-100 rounded-md" />
                </div>
            </div>
            <div className="bg-blue-400 h-1/2 w-full mt-20 p-1 lg:p-7">
                <div className="mx-8 my-20 p-4 lg:flex lg:max-w-full">
                    <div className="text-white text-3xl w-full lg:w-1/2 lg:text-5xl">
                        Teknologi Kami
                    </div>
                    <div className="w-full mt-8 lg:w-1/2 lg:mt-0">
                        <video controls src={Video} type="video/mp4" />
                    </div>
                </div>
            </div>
            <div className="p-6 mt-8 w-full">
                <h1 className="mb-9 text-2xl font-bold text-gray-900 w-1/2 lg:mx-4 ">Dukungan dari Kami</h1>
                <div className="lg:flex lg:mx-4 w-full justify-center">
                    <div className="w-auto mx-2">
                        <img src={TestImage} alt=''
                            className="lg:w-56 lg:h-56 rounded-md" />
                        <h1 className="mt-4 text-1xl font-bold text-gray-900">Real Time Monitoring</h1>
                        <p className="mt-4 text-1xl font-normal text-blue-900">Setiap energi terekam dalam bentuk digital</p>
                        <p className="mt-4 text-1xl font-normal text-gray-900">Dalam Setiap pemasangan dengan skema sewa milik, kami akan menyediakan akses online dalam rangka transaparansi pemakaian energi. </p>
                    </div>
                    <div className="w-auto mx-2">
                        <img src={TestImage} alt=''
                            className="lg:w-56 lg:h-56 rounded-md" />
                        <h1 className="mt-4 text-1xl font-bold text-gray-900">Garansi Performa</h1>
                        <p className="mt-4 text-1xl font-normal text-blue-900">Perawatan yang maksimal</p>
                        <p className="mt-4 text-1xl font-normal text-gray-900">Komponen yang kami sediakan didukung dengan garansi performa dari pabrikan serta sumber daya manusia yang berpengalaman. </p>
                    </div>
                    <div className="w-auto mx-2">
                        <img src={TestImage} alt=''
                            className="lg:w-56 lg:h-56 rounded-md" />
                        <h1 className="mt-4 text-1xl font-bold text-gray-900">Kemampuan Dalam Negeri</h1>
                        <p className="mt-4 text-1xl font-normal text-blue-900">Produksi dan Garansi dalam negeri</p>
                        <p className="mt-4 text-1xl font-normal text-gray-900">Panel Surya yang akan dipasang sudah memiliki sertifikasi dalam negeri & SNI.</p>
                    </div>
                </div>

            </div>
        </>
    )
}